import React, { createContext, useContext, useState, ReactNode } from 'react';

// Define the context type
interface ClickContextType {
  isClicked: boolean;
  setIsClicked: (clicked: boolean) => void;
}

// Create the context
const ClickContext = createContext<ClickContextType | undefined>(undefined);

// Provider Component
interface ClickProviderProps {
  children: ReactNode;
}

export const ClickProvider: React.FC<ClickProviderProps> = ({ children }) => {
  const [isClicked, setIsClicked] = useState(false);

  return (
    <ClickContext.Provider value={{ isClicked, setIsClicked }}>
      {children}
    </ClickContext.Provider>
  );
};

// Custom hook for using the context
export const useClickContext = (): ClickContextType => {
  const context = useContext(ClickContext);
  if (!context) {
    throw new Error('useClickContext must be used within a ClickProvider');
  }
  return context;
};
